export default __webpack_public_path__ + "static/media/rating.90d301b1.png";